import React from "react";
import "../../Css/Projects/Projects.css";

const FunWithAayush = () => {
  return (
    <div className="project">
      <div className="head">Fun With Aayush</div>
      <div className="desc">
        A simple rather interesting website using alot of different features in the web like canvas. This website contains some fun things I built on the web. I constantly try
        updating here and there. Its been a good side project for me. Also it quite inspired from Neal.fun
      </div>
      <div className="links">
        <a target="_" href="https://funwithaayush.pages.dev">
          Website
        </a>
        <a target="_" href="https://github.com/AayushMainali-Github/FunWithAayush">
          Github
        </a>
      </div>
    </div>
  );
};

export default FunWithAayush;
